// extracted by mini-css-extract-plugin
module.exports = {"badgeBase":"styles_badgeBase__oJs_a"};